const TRACKING_SELECTOR = "[data-analytics-button-id]"
const INSTAGRAM_CONTENT_SELECTOR = "[data-analytics-instagram-content-id]"
const SESSION_STATE_KEY = "ga4_page_view_session"
const SESSION_TIMEOUT_MS = 30 * 60 * 1000

let memorySessionState = null

function freshSessionState(now) {
  return {
    pageViews: 0,
    lastActivityAt: now,
    secondPageViewSent: false,
    entryPagePath: null
  }
}

function readSessionState(now = Date.now()) {
  let state = memorySessionState

  try {
    state = JSON.parse(window.sessionStorage.getItem(SESSION_STATE_KEY))
  } catch (_error) {
    // sessionStorageが利用できないブラウザではメモリ上の状態を使う。
  }

  if (!state || now - state.lastActivityAt >= SESSION_TIMEOUT_MS) {
    return freshSessionState(now)
  }

  return state
}

function writeSessionState(state) {
  memorySessionState = state

  try {
    window.sessionStorage.setItem(SESSION_STATE_KEY, JSON.stringify(state))
  } catch (_error) {
    // メモリ上の状態は維持されるため、計測処理は継続できる。
  }
}

function touchSession() {
  const now = Date.now()
  const state = readSessionState(now)
  state.lastActivityAt = now
  writeSessionState(state)
}

function trackPageViewProgress() {
  const now = Date.now()
  const state = readSessionState(now)
  const pagePath = `${window.location.pathname}${window.location.search}`

  state.pageViews += 1
  state.lastActivityAt = now
  state.entryPagePath ||= pagePath

  if (state.pageViews >= 2 && !state.secondPageViewSent && typeof window.gtag === "function") {
    window.gtag("event", "second_page_view", {
      entry_page_path: state.entryPagePath,
      page_path: pagePath,
      page_view_count: state.pageViews
    })
    state.secondPageViewSent = true
  }

  writeSessionState(state)
}

function trackButtonClick(event) {
  const element = event.target.closest(TRACKING_SELECTOR)
  if (!element || typeof window.gtag !== "function") return

  const linkUrl = element.href || ""

  window.gtag("event", "button_click", {
    button_id: element.dataset.analyticsButtonId,
    button_name: element.dataset.analyticsButtonName || element.textContent.trim(),
    button_category: element.dataset.analyticsButtonCategory || "other",
    destination_type: element.dataset.analyticsDestinationType || "internal",
    link_url: linkUrl,
    page_path: window.location.pathname
  })
}

function trackInstagramOutboundClick(event) {
  const element = event.target.closest(INSTAGRAM_CONTENT_SELECTOR)
  if (!element || typeof window.gtag !== "function") return

  window.gtag("event", "instagram_outbound_click", {
    content_id: element.dataset.analyticsInstagramContentId,
    content_title: element.dataset.analyticsContentTitle || "",
    content_position: Number(element.dataset.analyticsContentPosition),
    link_url: element.href || "",
    page_path: `${window.location.pathname}${window.location.search}`
  })
}

document.addEventListener("click", trackButtonClick)
document.addEventListener("click", trackInstagramOutboundClick)
document.addEventListener("click", touchSession, { capture: true })
document.addEventListener("turbo:load", trackPageViewProgress)
